import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@mui/material';

export type ToolbarContainerProps = PropsWithChildren & BoxProps;

export const ToolbarContainer: React.FC<ToolbarContainerProps> = ({ children, className, ...props }) => {
  return (
    <Box
      className={`toolbar-div pad-sides ${className}`}
      height="64px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      {children}
    </Box>
  );
};
